import React, { FormEvent, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Toolbar from '@material-ui/core/Toolbar';

import { useAppState } from '../../state';
import { getCallTokenParam, JoinError, JoinErrorKind } from '../../state/callToken/callToken';
import { getJoinErrorMessage } from '../../state/callToken/joinErrorMessages';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.default,
    },
    form: {
      display: 'flex',
      alignItems: 'center',
    },
    loadingSpinner: {
      marginLeft: '1em',
    },
  })
);

export default function MenuBar() {
  const classes = useStyles();
  const { getToken, isFetching } = useAppState();
  const { isConnecting, connect } = useVideoContext();

  // A link without `ct` is invalid before anything is requested.
  const [joinError, setJoinError] = useState<JoinErrorKind | null>(() => (getCallTokenParam() ? null : 'invalidLink'));

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setJoinError(null);
    getToken()
      .then(token => connect(token))
      .catch(error => setJoinError(error instanceof JoinError ? error.kind : 'unavailable'));
  };

  return (
    <AppBar className={classes.container} position="static">
      <Toolbar>
        {joinError && joinError !== 'unavailable' ? (
          <p className="join-error">{getJoinErrorMessage(joinError)}</p>
        ) : (
          <form className={classes.form} onSubmit={handleSubmit}>
            <h2>Ready to Join?</h2>
            {joinError === 'unavailable' ? (
              <p className="join-error join-error--retry">{getJoinErrorMessage(joinError)}</p>
            ) : (
              <p>Check your Mic & Camera before joining the call.</p>
            )}
            <Button type="submit" color="primary" variant="contained" disabled={isConnecting || isFetching}>
              Join Room
            </Button>
            {(isConnecting || isFetching) && <CircularProgress className={classes.loadingSpinner} />}
          </form>
        )}
      </Toolbar>
    </AppBar>
  );
}
